// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".common-cls1___de7f5728abd1bf23121{/*!*/}.common-cls2___a4d0048b87e6d38477e{color:#141413;color:var(--text-primary, #141413);text-align:center;padding-bottom:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "common-cls1___de7f5728abd1bf23121",
	"cls2": "common-cls2___a4d0048b87e6d38477e common-cls1___de7f5728abd1bf23121"
};
export default ___CSS_LOADER_EXPORT___;
